import CategoryIconsBlock from './categoryIconsBlock'

export default CategoryIconsBlock
